import React from "react";
import InfoContainerPolestar from "../InfoContainer/InfoContainerPolestar";
import EventsComponentPolestar from "../EventsPolestar";
import { observer } from "mobx-react-lite";

const StatusContainer = () => {
  return (
    <div>
      <div id="StatusContainerMain">
        <EventsComponentPolestar />
      </div>
      <InfoContainerPolestar />
    </div>
  );
};

export default observer(StatusContainer);
